import { render, staticRenderFns } from "./Discount_List.vue?vue&type=template&id=1056b5ab&scoped=true&"
import script from "./Discount_List.vue?vue&type=script&lang=js&"
export * from "./Discount_List.vue?vue&type=script&lang=js&"
import style0 from "./Discount_List.vue?vue&type=style&index=0&id=1056b5ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1056b5ab",
  null
  
)

export default component.exports